import { createFileRoute } from '@tanstack/react-router';
import CandidatesInterviewLogNewTemplate from '@/features/agent/candidates/templates/CandidatesInterviewLogNewTemplate';

type CandidatesInterviewLogNewSearch = {
  source?: 'transcript';
};

export const Route = createFileRoute('/agent/candidates/$candidateProfileId/interview_logs/new/')({
  validateSearch: (search: Record<string, unknown>): CandidatesInterviewLogNewSearch => ({
    source: search.source === 'transcript' ? 'transcript' : undefined,
  }),
  component: CandidatesInterviewLogNew,
});

function CandidatesInterviewLogNew() {
  const { candidateProfileId } = Route.useParams();
  const { source } = Route.useSearch();

  return (
    <CandidatesInterviewLogNewTemplate
      candidateProfileId={Number(candidateProfileId)}
      fromTranscript={source === 'transcript'}
    />
  );
}
